/**
 * 如果流程提前终止，外面会收到这个异常
 */
export default class FlowAbortError extends Error {
  /**
   * @param {UICore.SimpleFlowExecuteCtx} flowCtx
   */
  constructor(flowCtx) {
    super(`Event flow is aborted at step ${flowCtx.index}`);
    this.flowCtx = flowCtx;
    this.isFlowAbortError = true;
  }
}
//# sourceMappingURL=FlowAbortError.js.map
